import { oc } from '@orpc/contract';
import { scenarioSchema, updateScenarioInputSchema } from '../schemas/scenarios.schemas.js';
export const updateScenarioContract = oc
    .route({
    method: 'PUT',
    path: '/scenarios/{id}',
    tags: ['Scenarios'],
    summary: 'Replace a test scenario definition',
    description: 'MANAGER only. The dimension tuple stays unique across every other scenario.',
})
    .input(updateScenarioInputSchema)
    .output(scenarioSchema);
//# sourceMappingURL=update-scenario.contract.js.map